import F from 'offline/filter/constants'
// Port of api/fuel/app/classes/filter/package/games/collection/prepare/dates.php
export default {
	run: function(local, global) {
		if (global.ownerType !== F.OWNER_USER) return local
		local.collection = local.collection || {}
		var coll = global.collections ? global.collections[local.id] : null
		local.collection.dates = coll ? { added: coll.collection_date_owned || 0, updated: coll.collection_date_updated || 0 } : { added: 0, updated: 0 }
		return local
	}
}
